<template>
  <div class="live-dashboard vh-100 d-flex flex-column">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="2"
      >
        <counter-card-2
          title-text="Çözümlendi"
          sub-title-text="YTD - MTD"
          :value-data="dashboardData.counters.resolved.ytd | toNumber"
          :value2-data="dashboardData.counters.resolved.mtd | toNumber"
          color-class="success"
          prefix-text=""
          prefix2-text=""
          suffix-text=""
          suffix2-text=""
          icon-name="CheckCircleIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <counter-card
          title-text="Takip Ediliyor"
          sub-title-text="Anlık"
          :value-data="dashboardData.counters.followUp | toNumber"
          color-class="info"
          prefix-text=""
          suffix-text=""
          icon-name="EyeIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <counter-card
          title-text="Onay Bekliyor"
          sub-title-text="Anlık"
          :value-data="dashboardData.counters.waitingForApproval | toNumber"
          color-class="warning"
          prefix-text=""
          suffix-text=""
          icon-name="InfoIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <counter-card-2
          title-text="Beklemede"
          sub-title-text="Anlık"
          :value-data="dashboardData.counters.pending.count | toNumber"
          :value2-data="dashboardData.counters.pending.duration"
          color-class="danger"
          prefix-text=""
          prefix2-text=""
          suffix-text="Adet"
          suffix2-text=""
          icon-name="AlertTriangleIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <counter-card
          title-text="İlk Yanıt"
          sub-title-text="YTD Ortalama"
          :value-data="dashboardData.counters.answerAvg"
          color-class="info"
          prefix-text=""
          suffix-text=""
          icon-name="ClockIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <counter-card
          title-text="Çözüm Yanıtı"
          sub-title-text="YTD Ortalama"
          :value-data="dashboardData.counters.solutionAvg"
          color-class="info"
          prefix-text=""
          suffix-text=""
          icon-name="ClockIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Aylık Bazlı Çözümlenme Grafiği"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="monthly"
          />
          <div
            v-if="loadings.monthly"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <area-charts
              v-if="dashboardData.monthly.series.length"
              :series-data="dashboardData.monthly.series"
              :categories-data="dashboardData.monthly.categories"
              :unresolved-data="dashboardData.monthly.unresolved"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka - Departman Bazlı Şikayet Adedi"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="complaints"
          />
          <div
            v-if="loadings.complaints"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-bar-charts
              :series-data="dashboardData.complaints.series"
              :categories-data="dashboardData.complaints.categories"
              :colors-data="dashboardData.complaints.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Departman Bazlı Başvuru Durumu"
            card-sub-title="Anlık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="departmentsStatus"
          />
          <div
            v-if="loadings.departmentsStatus"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-vertical-bar-charts
              :series-data="dashboardData.departmentsStatus.series"
              :categories-data="dashboardData.departmentsStatus.categories"
              :colors-data="dashboardData.departmentsStatus.colors"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header-filter
            card-title="En Çok Başvuru Alan 10 Konu"
            card-sub-title="Anlık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="bestSubjects"
          />
          <div
            v-if="loadings.bestSubjects"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-bar-charts
              :series-data="dashboardData.bestSubjects.series"
              :categories-data="dashboardData.bestSubjects.categories"
              :colors-data="dashboardData.bestSubjects.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı Başvuru Durumu"
            card-sub-title="Anlık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandsStatus"
          />
          <div
            v-if="loadings.brandsStatus"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-vertical-bar-charts
              :series-data="dashboardData.brandsStatus.series"
              :categories-data="dashboardData.brandsStatus.categories"
              :colors-data="dashboardData.brandsStatus.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Lokasyon Bazlı Müşteri Skoru"
            card-sub-title="Aylık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="locationPerformance"
          />
          <div
            v-if="loadings.locationPerformance"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <location-performance
              :data-list="dashboardData.locationPerformance.data"
              :grand-totals="dashboardData.locationPerformance.grandTotals"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <report-customizer
      :cache-info="cacheInfo"
      :refresh-data="refreshDashboard"
      :start-countdown="startCountdown"
    />
  </div>
</template>
<script>
import {
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'
import ReportCustomizer from '@/views/Dashboard/Live/Components/ReportCustomizer.vue'
import CounterCard from '@/views/Dashboard/Live/Components/CounterCardSmall.vue'
import CounterCard2 from '@/views/Dashboard/Live/Components/CounterCardSmall2.vue'
import PreLoading from '@/layouts/components/Loading.vue'
// import ColumnCharts from '@/views/Dashboard/Live/Charts/ColumnCharts.vue'
// import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
import AreaCharts from '@/views/Dashboard/Live/CrmDashboard/AreaCharts.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import CardCustomHeaderFilter from '@/views/Dashboard/Live/CrmDashboard/CardCustomHeaderFilter.vue'
import StackedVerticalBarCharts from '@/views/Dashboard/Live/CrmDashboard/StackedVerticalBarCharts.vue'
import StackedBarCharts from '@/views/Dashboard/Live/CrmDashboard/StackedBarCharts.vue'
import LocationPerformance from '@/views/Dashboard/Live/CrmDashboard/LocationPerformance.vue'

export default {
  name: 'CrmDashboard',
  components: {
    BCard,
    BRow,
    BCol,
    LocationPerformance,
    // ColumnCharts,
    // PieCharts,
    StackedVerticalBarCharts,
    StackedBarCharts,
    CardCustomHeader,
    CardCustomHeaderFilter,
    AreaCharts,
    PreLoading,
    CounterCard,
    CounterCard2,
    ReportCustomizer,
  },
  data() {
    return {
      intervalId: null,
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveCrmDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveCrmDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveCrmDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
    filterData() {
      return this.$store.getters['liveCrmDashboard/filterData']
    },
    filterParams() {
      return this.$store.getters['liveCrmDashboard/filterParams']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getDashboard()
    this.getFilterData()
  },
  methods: {
    getFilterData() {
      this.$store.dispatch('liveCrmDashboard/getFilterData')
    },
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('counters')
      this.getData('monthly')
      this.getData('complaints')
      this.getData('departmentsStatus')
      this.getData('bestSubjects')
      this.getData('brandsStatus')
      this.getData('locationPerformance')
    },
    refreshDashboard() {
      this.$store.commit('liveCrmDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('monthly')
      this.refreshData('complaints')
      this.refreshData('departmentsStatus')
      this.refreshData('bestSubjects')
      this.refreshData('brandsStatus')
      this.refreshData('locationPerformance')
    },
    getData(type) {
      this.$store.dispatch('liveCrmDashboard/getData', {
        type,
        id_com_brand: this.filterParams.bestSubjects.id_com_brand,
      })
    },
    refreshData(type) {
      this.$store.dispatch('liveCrmDashboard/refreshData', {
        type,
        id_com_brand: this.filterParams.bestSubjects.id_com_brand,
      })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  //overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
